import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'common-typing-animation',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './typing-animation.component.html',
  styleUrl: './typing-animation.component.scss',
})
export class TypingAnimationComponent {}
